var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-filter-form',{attrs:{"filter":_vm.filterForm,"fields":_vm.allFields,"default-common-fields":_vm.defaultCommonFields,"default-more-fields":_vm.defaultMoreFields,"config-key":"venueFilterConfig"},on:{"change":_vm.handleFieldChange,"search":_vm.handleSearch,"reset":_vm.handleReset},scopedSlots:_vm._u([{key:"field",fn:function({ field, form, reset, labelCol, wrapperCol }){return [_c('venue-filter-form-item',{attrs:{"form":form,"field":field,"options":{
        statusList: _vm.venueStatusList,
        venueTypes: _vm.venueTypeList,
        projectOptions: _vm.projectOptions
      },"search-data":{
        requirements: {
          searching: _vm.requirementSearching,
          data: _vm.searchRequirementData
        },
        teams: {
          searching: _vm.teamSearching,
          data: _vm.searchTeamData
        }
      },"reset":reset,"label-col":labelCol,"wrapper-col":wrapperCol},on:{"change":_vm.handleFieldChange,"search":_vm.handleFieldSearch}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }